












































import {
    ref,
    defineComponent
} from "@vue/composition-api";
import useSensorHistory from "@/store/useSensorHistory";
import useDevice from "@/utilities/useDevice";
import moment from 'moment-timezone';
import useUserSettings from "@/store/useUserSettings";
import UserSettingsViewModel from "@/models/UserSettingsViewModel";

export default defineComponent({
    setup(_, context) {
        const id = context.root.$route.params.id;
        const { getUserSettings } = useUserSettings();
        const userSettings = ref<UserSettingsViewModel>();
        getUserSettings().then((value: UserSettingsViewModel) => {
            userSettings.value = value;
        });
        const { logItems } = useSensorHistory(id);
        const formatModifiedDate = (modifiedDate) => {
            return moment.utc(modifiedDate).tz(userSettings.value.timezone).format("MMM DD, YYYY HH:mm:ss");
        };
        const sensorId = parseInt(id);
        const sensorName = useDevice().getName(sensorId).toUpperCase();

        const goBack = () => {
            window.history.back();
        };

        return {
            logItems,
            sensorName,
            formatModifiedDate,
            goBack
        };
    }
});
